export const hasPermission = (userPermissions, requiredPermission) => {
    return userPermissions?.includes(requiredPermission);
};

export const hasAnyPermission = (userPermissions, requiredPermissions) => {
    return userPermissions?.some(permission => requiredPermissions?.includes(permission));
};